/**
 * Holistipet — Shared ration calculator data & logic
 * Loaded by both the section page and the drawer snippet.
 */
if (!window.HolistipetRation) {
  window.HolistipetRation = (function() {
    'use strict';

    /* Breed data: [male_avg_kg, female_avg_kg, senior_age_years] */
    var BREEDS = {
      "Affenpinscher":[4,3.5,9],"Afghan Hound (Lévrier Afghan)":[27,23,8],"Airedale Terrier":[25,21,8],
      "Akita Américain":[45,35,7],"Akita Inu":[35,28,7],"Alaskan Malamute":[38,34,7],
      "American Staffordshire Terrier":[28,23,8],"Azawakh":[23,20,8],"Barbet":[25,20,8],
      "Barzoï (Lévrier Russe)":[41,34,7],"Basenji":[11,10,10],"Basset Artésien Normand":[18,16,9],
      "Basset Bleu de Gascogne":[20,18,9],"Basset Fauve de Bretagne":[18,16,9],"Basset Hound":[29,25,8],
      "Beagle":[12,11,9],"Beagle-Harrier":[22,20,8],"Bedlington Terrier":[10,9,10],
      "Berger Allemand":[34,28,7],"Berger Australien":[30,25,8],"Berger Belge Groenendael":[28,23,8],
      "Berger Belge Laekenois":[28,23,8],"Berger Belge Malinois":[30,25,8],"Berger Belge Tervueren":[28,23,8],
      "Berger Blanc Suisse":[35,30,7],"Berger Catalan":[22,18,8],"Berger de Beauce":[40,32,7],
      "Berger de Brie":[38,30,7],"Berger de Maremme et Abruzzes":[40,35,7],
      "Berger des Pyrénées (face rase)":[12,10,10],"Berger des Pyrénées (poil long)":[11,9,10],
      "Berger des Shetland":[10,8,10],"Berger Hollandais (poil court)":[28,23,8],
      "Berger Hollandais (poil dur)":[28,23,8],"Berger Hollandais (poil long)":[28,23,8],
      "Berger Picard":[28,23,8],"Berger Polonais de Plaine":[20,18,9],
      "Bichon Frisé":[6,5,10],"Bichon Havanais":[6,5,10],"Bichon Maltais":[4,3,11],
      "Bloodhound (Chien de Saint-Hubert)":[46,40,6],"Border Collie":[20,18,9],"Border Terrier":[7,6,11],
      "Bouvier Australien":[20,18,9],"Bouvier Bernois":[50,40,6],"Bouvier d'Appenzell":[27,23,8],
      "Bouvier de l'Entlebuch":[30,25,7],"Bouvier des Ardennes":[28,23,8],"Boxer":[32,27,7],
      "Braque Allemand à poil court":[32,27,8],"Braque Allemand à poil dur":[32,27,8],
      "Braque de Weimar":[35,30,8],"Braque du Bourbonnais":[25,22,8],
      "Braque Français type Gascogne":[25,22,8],"Braque Français type Pyrénées":[25,22,8],
      "Braque Hongrois (Vizsla)":[27,23,8],"Braque Saint-Germain":[25,22,8],
      "Brussels Griffon (Griffon Bruxellois)":[5,4.5,11],"Bruno du Jura":[32,28,8],
      "Bullmastiff":[55,48,6],"Cairn Terrier":[7,6,11],"Cane Corso":[45,40,7],
      "Cavalier King Charles":[8,7,10],"Cesky Terrier":[10,9,10],"Chesapeake Bay Retriever":[34,29,8],
      "Chien courant Italien (Segugio Italiano)":[25,22,8],"Chien courant Polonais (Gończy Polski)":[20,18,9],
      "Chien d'Artois":[28,25,8],"Chien d'Eau Espagnol":[20,17,9],"Chien d'Eau Portugais":[22,19,9],
      "Chien du Groenland":[32,28,8],"Chien Loup de Saarloos":[36,30,7],
      "Chien Loup Tchécoslovaque":[30,25,8],"Chihuahua":[3,2.5,11],"Chow Chow":[30,25,8],
      "Clumber Spaniel":[34,29,8],"Cocker Spaniel Américain":[13,11,9],"Cocker Spaniel Anglais":[15,13,9],
      "Colley à poil court":[27,23,8],"Colley à poil long":[27,23,8],"Coton de Tuléar":[6,5,11],
      "Curly Coated Retriever":[36,32,8],"Dandie Dinmont Terrier":[10,9,10],
      "Deerhound (Lévrier Écossais)":[45,36,6],"Dobermann":[40,32,7],"Dogue Allemand":[70,55,6],
      "Dogue de Bordeaux":[60,50,6],"Épagneul Breton":[18,15,9],"Épagneul Picard":[20,18,9],
      "Épagneul Pont-Audemer":[22,19,9],"Eurasier":[27,22,8],"Fila Brasileiro":[50,40,6],
      "Flat Coated Retriever":[34,30,8],"Fox Terrier poil dur":[8,7,11],"Fox Terrier poil lisse":[8,7,11],
      "Foxhound Anglais":[34,30,8],"Galgo Español":[27,23,8],"Golden Retriever":[34,29,8],
      "Grand Bleu de Gascogne":[38,32,7],"Grand Bouvier Suisse":[60,50,6],
      "Greyhound (Lévrier Anglais)":[32,27,8],"Harrier":[22,20,8],"Irish Terrier":[13,12,9],
      "Irish Wolfhound (Lévrier Irlandais)":[65,55,6],"Jack Russell Terrier":[7,6,11],
      "Japanese Chin":[4,3.5,11],"Keeshond (Spitz Néerlandais)":[30,25,8],
      "Kerry Blue Terrier":[17,15,9],"Labrador Retriever":[36,30,8],"Lagotto Romagnolo":[16,14,9],
      "Lakeland Terrier":[8,7,11],"Lhasa Apso":[7,6,11],"Löwchen":[7,6,11],
      "Manchester Terrier":[9,8,10],"Mâtin Espagnol":[70,60,6],"Mâtin Napolitain":[65,55,6],
      "Norfolk Terrier":[6,5,11],"Norwich Terrier":[6,5,11],"Papillon":[4,3.5,11],
      "Pékinois":[5,4,11],"Petit Chien Lion":[6,5,11],"Pinscher moyen":[14,12,10],
      "Pinscher nain":[5,4,11],"Pointer Anglais":[30,25,8],"Porcelaine":[28,25,8],
      "Rottweiler":[50,42,7],"Saluki":[25,20,8],"Samoyède":[27,23,8],
      "Schapendoes Néerlandais":[18,15,9],"Schnauzer géant":[42,35,7],"Schnauzer moyen":[14,12,10],
      "Schnauzer nain":[5,4,11],"Scottish Terrier":[9,8,10],"Sealyham Terrier":[9,8,10],
      "Setter Anglais":[30,25,8],"Setter Gordon":[30,26,8],"Setter Irlandais":[32,28,8],
      "Shiba Inu":[11,9,10],"Shih Tzu":[7,6,11],"Siberian Husky":[25,20,8],
      "Skye Terrier":[11,9,10],"Sloughi":[25,20,8],"Soft Coated Wheaten Terrier":[18,16,9],
      "Spitz Allemand loup":[30,25,8],"Spitz Allemand moyen":[10,8,10],"Spitz Allemand nain":[5,4,11],
      "Spitz Japonais":[10,8,10],"Springer Anglais":[20,18,9],"Staffordshire Bull Terrier":[16,14,9],
      "Tazy":[35,30,7],"Teckel kaninchen poil dur":[3,2.5,11],"Teckel kaninchen poil long":[3,2.5,11],
      "Teckel kaninchen poil ras":[3,2.5,11],"Teckel nain poil dur":[5,4.5,11],
      "Teckel nain poil long":[5,4.5,11],"Teckel nain poil ras":[5,4.5,11],
      "Teckel standard poil dur":[9,8,10],"Teckel standard poil long":[9,8,10],
      "Teckel standard poil ras":[9,8,10],"Tosa Inu":[60,50,6],
      "West Highland White Terrier":[8,7,11],"Whippet":[13,11,9],"Wire Fox Terrier":[8,7,11],
      "Yorkshire Terrier":[3,2.5,11],
      "Berger d'Anatolie (Kangal)":[58,46,6],"Komondor":[52,42,6],"Épagneul Français":[26,22,8],
      "Springer Spaniel anglais":[24,21,8],"Cavalier King Charles Spaniel":[7.5,6.5,10],
      "Spitz Finlandais":[14,10,9],"Chien finnois de Laponie":[19,17,8],"Bull Terrier":[30,25,7],
      "Dogue Argentin":[43,38,6],"Hovawart":[36,31,7],"Leonberg":[68,55,6],"Terre-Neuve":[65,54,6],
      "Basset de Westphalie":[16,15,9],"Griffon Fauve de Bretagne":[20,18,8],"Rhodesian Ridgeback":[39,33,7],
      "Boston Terrier":[9,8,10],"Bouledogue Français":[12,10.5,9],"Bouledogue Anglais":[24,22,7],
      "Carlin":[8,7,10],"Lévrier hongrois (Magyar Agár)":[29,24,8]
    };

    /* Adult ration table — index = weight in kg (1-60)
       Each row: [moderate, normal, elevated, senior, sterilized] */
    var ADULT = [
      null,
      [25,30,35,25,25],[45,55,60,45,40],[60,75,80,60,55],[70,90,100,70,70],[85,105,120,85,80],
      [100,120,135,100,90],[110,135,150,110,100],[120,150,170,120,110],[130,165,185,130,120],
      [140,180,200,140,130],[149,190,212,149,140],[158,200,224,158,150],[167,210,236,167,160],
      [176,220,248,176,170],[185,230,260,185,180],[193,240,270,193,188],[201,250,280,201,196],
      [209,260,290,209,204],[217,270,300,217,212],[225,280,310,225,220],[234,289,320,234,226],
      [243,298,330,243,232],[252,307,340,252,238],[261,316,350,261,244],[270,325,360,270,250],
      [275,334,370,275,256],[280,343,380,280,262],[285,352,390,285,268],[290,361,400,290,274],
      [295,370,410,295,280],[300,378,420,300,288],[305,386,430,305,296],[310,394,440,310,304],
      [315,402,450,315,312],[320,410,460,320,320],[328,418,468,328,326],[336,426,476,336,332],
      [344,434,484,344,338],[352,442,492,352,344],[360,450,500,360,350],[365,458,508,365,356],
      [370,466,516,370,362],[375,474,524,375,368],[380,482,532,380,374],[385,490,540,385,380],
      [391,496,548,391,386],[397,502,556,397,392],[403,508,564,403,398],[409,514,572,409,404],
      [415,520,580,415,410],[420,528,572,420,418],[425,536,564,425,426],[430,544,556,430,434],
      [435,552,548,435,442],[440,560,540,440,450],[446,566,562,446,456],[452,572,584,452,462],
      [458,578,606,458,468],[464,584,628,464,474],[470,590,650,470,480]
    ];

    /* Puppy ration table — index = estimated adult weight in kg (1-60)
       Each row: [2-3 months, 4-5 months, 6-7 months, 8-9 months, 10-11 months]
       0 means "use adult table" */
    var PUPPY = [
      null,
      [40,45,40,35,0],[55,60,55,50,0],[70,75,70,65,0],[85,95,90,85,0],[105,115,105,100,0],
      [115,125,120,115,0],[135,150,145,130,125],[145,165,150,140,140],[160,180,175,160,155],
      [170,190,180,175,170],[184,205,194,187,181],[198,220,208,199,192],[212,235,222,211,203],
      [226,250,236,223,214],[240,265,250,235,225],[246,272,264,246,236],[252,279,278,257,247],
      [258,286,292,268,258],[264,293,306,279,269],[270,300,320,290,280],[275,312,330,302,288],
      [280,324,340,314,296],[285,336,350,326,304],[290,348,360,338,312],[295,360,370,350,320],
      [304,378,386,366,336],[313,396,402,382,352],[322,414,418,398,368],[331,432,434,414,384],
      [340,450,450,430,400],[342,458,462,444,408],[344,466,474,458,416],[346,474,486,472,424],
      [348,482,498,486,432],[350,490,510,500,440],[358,494,520,508,450],[366,498,530,516,460],
      [374,502,540,524,470],[382,506,550,532,480],[390,510,560,540,490],[393,518,570,552,496],
      [396,526,580,564,502],[399,534,590,576,508],[402,542,600,588,514],[405,550,610,600,520],
      [408,552,614,608,532],[411,554,618,616,544],[414,556,622,624,556],[417,558,626,632,568],
      [420,560,630,640,580],[424,564,640,648,590],[428,568,650,656,600],[432,572,660,664,610],
      [436,576,670,672,620],[440,580,680,680,630],[444,585,688,0,0],[448,590,696,0,0],
      [452,595,704,0,0],[456,600,712,0,0],[460,605,720,0,0]
    ];

    function clampWeight(kg) {
      return Math.max(1, Math.min(60, Math.round(kg)));
    }

    function getAgeBracketIndex(totalMonths) {
      if (totalMonths <= 3) return 0;
      if (totalMonths <= 5) return 1;
      if (totalMonths <= 7) return 2;
      if (totalMonths <= 9) return 3;
      return 4;
    }

    function calculate(data) {
      var totalMonths = data.ageYears * 12 + data.ageMonths;
      var isPuppy = totalMonths < 12;
      var breed = BREEDS[data.breed];
      var isSterilized = data.sterilized === 'oui';
      var notes = [];

      if (totalMonths < 2) {
        return { error: "Le calculateur est conçu pour les chiens à partir de 2 mois." };
      }
      if (isPuppy && !breed) {
        return { error: "Veuillez sélectionner une race pour calculer la ration d'un chiot." };
      }

      var weightKg;
      if (isPuppy) {
        weightKg = data.sex === 'male' ? breed[0] : breed[1];
        notes.push("Chiot : le calcul est basé sur le poids adulte estimé de la race (" + weightKg + " kg).");
      } else {
        weightKg = data.weightKg + data.weightG / 1000;
        if (weightKg <= 0) {
          return { error: "Veuillez renseigner le poids de votre chien." };
        }
      }

      var lookupKg = clampWeight(weightKg);
      var grams;

      if (isPuppy) {
        var bracketIdx = getAgeBracketIndex(totalMonths);
        var puppyRow = PUPPY[lookupKg];
        if (!puppyRow || puppyRow[bracketIdx] === 0) {
          var adultRow = ADULT[lookupKg];
          grams = adultRow ? adultRow[1] : null;
          notes.push("Ration adulte appliquée (le chiot est assez grand pour cette tranche d'âge).");
        } else {
          grams = puppyRow[bracketIdx];
        }
      } else {
        var isSenior = false;
        if (breed) {
          isSenior = (totalMonths >= breed[2] * 12);
        }
        var adultRow = ADULT[lookupKg];
        if (!adultRow) {
          return { error: "Le poids dépasse les tables de ration disponibles (max 60 kg)." };
        }
        if (isSterilized) {
          grams = adultRow[4];
          notes.push("Ration adaptée pour chien stérilisé.");
        } else if (isSenior) {
          grams = adultRow[3];
          notes.push("Votre chien est considéré senior pour sa race. Ration adaptée.");
        } else {
          var activityMap = { moderate: 0, normal: 1, elevated: 2 };
          var colIdx = activityMap[data.activity];
          if (colIdx === undefined) {
            return { error: "Veuillez sélectionner un niveau d'activité." };
          }
          grams = adultRow[colIdx];
        }
      }

      if (!grams) {
        return { error: "Impossible de calculer la ration avec les données fournies." };
      }

      return { grams: grams, notes: notes, isPuppy: isPuppy };
    }

    /**
     * Populate a <select> element with breed options.
     */
    function populateBreedSelect(selectEl) {
      var names = Object.keys(BREEDS).sort(function(a, b) {
        return a.localeCompare(b, 'fr');
      });
      names.forEach(function(name) {
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        selectEl.appendChild(opt);
      });
    }

    /**
     * Bind stepper +/- buttons within a container.
     */
    function initSteppers(container) {
      container.querySelectorAll('.ration-form__stepper-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var input = container.querySelector('#' + this.getAttribute('data-target'));
          if (!input) return;
          var step = parseInt(this.getAttribute('data-step')) || 1;
          var min = parseInt(input.min) || 0;
          var max = parseInt(input.max) || 9999;
          var cur = parseInt(input.value) || 0;
          input.value = this.getAttribute('data-action') === 'increment'
            ? Math.min(cur + step, max)
            : Math.max(cur - step, min);
        });
      });
    }

    /**
     * Bind tooltip toggles within a container.
     */
    function initTooltips(container) {
      container.querySelectorAll('.ration-form__tooltip').forEach(function(tip) {
        tip.addEventListener('click', function(e) {
          e.stopPropagation();
          this.classList.toggle('is-active');
        });
      });
    }

    /**
     * Read form values from a <form> element.
     */
    function readFormData(form) {
      return {
        name: form.dog_name.value.trim(),
        sex: form.dog_sex.value,
        breed: form.dog_breed.value,
        sterilized: form.dog_sterilized.value,
        ageYears: parseInt(form.dog_age_years.value) || 0,
        ageMonths: parseInt(form.dog_age_months.value) || 0,
        weightKg: parseInt(form.dog_weight_kg.value) || 0,
        weightG: parseInt(form.dog_weight_g.value) || 0,
        activity: form.dog_activity.value,
        flavor: form.dog_flavor.value
      };
    }

    /**
     * Validate form data. Returns error string or null.
     */
    function validate(data) {
      if (!data.breed) return "Veuillez sélectionner une race.";
      if (data.ageYears === 0 && data.ageMonths === 0) return "Veuillez renseigner l'âge de votre chien.";
      var totalMonths = data.ageYears * 12 + data.ageMonths;
      var isPuppy = totalMonths < 12;
      if (!isPuppy && data.weightKg === 0 && data.weightG === 0) return "Veuillez renseigner le poids de votre chien.";
      if (!isPuppy && data.sterilized !== 'oui') {
        var isSenior = false;
        var breed = BREEDS[data.breed];
        if (breed) isSenior = totalMonths >= breed[2] * 12;
        if (!isSenior && !data.activity) return "Veuillez sélectionner un niveau d'activité.";
      }
      return null;
    }

    return {
      BREEDS: BREEDS,
      calculate: calculate,
      validate: validate,
      readFormData: readFormData,
      populateBreedSelect: populateBreedSelect,
      initSteppers: initSteppers,
      initTooltips: initTooltips
    };
  })();
}
